import React from "react";
import { Box, Typography } from "@mui/material";
import { FileDownloadOutlined, DeleteOutline } from "@mui/icons-material";

import { CardLayout, IconButton } from "../v3";
import { useHasPermission } from "../../utils";
import { DELETE_PROJECT, GENERATE_PROJECT_REPORT } from "../../constants";

export const ProjectActions = ({ onDownload = () => {}, onDelete = () => {} }) => {
  const hasDownloadReport = useHasPermission(GENERATE_PROJECT_REPORT);
  const hasDeleteProject = useHasPermission(DELETE_PROJECT);

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
      }}
    >
      {/* download report */}
      {hasDownloadReport && (
        <Box sx={{ flex: "1 1 50%" }}>
          <CardLayout sx={{ margin: "11px", padding: "11px" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
              }}
            >
              <Typography>Download Report</Typography>
              <IconButton
                icon={<FileDownloadOutlined />}
                tooltip="Download Report"
                onClick={onDownload}
                styles={{ color: "#674BF5", backgroundColor: "#EBE9F9", fontSize: "16px", fontWeight: 500 }}
                hoverStyles={{ color: "#fff", backgroundColor: "#674BF5" }}
              />
            </Box>
          </CardLayout>
        </Box>
      )}

      {/* delete project */}
      {hasDeleteProject && (
        <Box sx={{ flex: "1 1 50%" }}>
          <CardLayout sx={{ margin: "11px", padding: "11px" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
              }}
            >
              <Typography>Delete Project</Typography>
              <IconButton
                icon={<DeleteOutline />}
                tooltip="Delete Project"
                onClick={onDelete}
                styles={{ color: "#FFB8B8", backgroundColor: "#FFE6E6", fontSize: "16px", fontWeight: 500 }}
                hoverStyles={{ color: "#fff", backgroundColor: "#f44336" }}
              />
            </Box>
          </CardLayout>
        </Box>
      )}
    </Box>
  );
};
